export default __webpack_public_path__ + "static/media/tokit3.1ac91ea9.png";